import { useMemo } from 'react';
import { IWorkspaceInfo } from 'src/@types/workspace-info';
import { useSelector } from 'src/redux/store';
import { SoundBoardData } from 'src/requests/soundboard';
import { useSoundBoardsQuery } from './useSoundBoardsQuery';

type SoundGroup = {
  group: Partial<IWorkspaceInfo>;
  icon?: string;
  default?: boolean;
  sounds: SoundBoardData[];
};

export const useSoundData = ({
  searchSound = '',
}: { searchSound: string }): SoundGroup[] => {
  const workspace = useSelector((state) => state.workspace.workspace);

  const { sounds } = useSoundBoardsQuery();

  const { coperaSounds, workspaceSounds } = useMemo(() => {
    const coperaSounds: SoundBoardData[] = [];
    const workspaceSounds: SoundBoardData[] = [];

    if (sounds.length) {
      sounds.forEach((sound) => {
        if (searchSound && !sound.name.toLowerCase().includes(searchSound))
          return;
        sound.createdBy === 'DEFAULT'
          ? coperaSounds.push(sound)
          : workspaceSounds.push(sound);
      });
    }

    return { coperaSounds, workspaceSounds };
  }, [sounds, searchSound]);

  return [
    {
      group: { name: 'Copera' },
      icon: 'copera:logo',
      default: true,
      sounds: coperaSounds,
    },
    {
      group: workspace,
      sounds: workspaceSounds,
    },
  ];
};
